/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { errorResponseSchema } from "../errorResponseSchema.ts";
import { userSchema } from "../userSchema.ts";
import { z } from "zod";

export const getCurrentUserHeaderParamsSchema = z.object({
      "X-Client-Id": z.string().describe("ID du client/application")
      })

/**
 * @description Informations utilisateur récupérées avec succès.
 */
export const getCurrentUser200Schema = z.lazy(() => userSchema)

/**
 * @description Réponse d\'erreur standard
 */
export const getCurrentUser404Schema = z.lazy(() => errorResponseSchema).describe("Réponse d'erreur avec message et code de statut")

export const getCurrentUserQueryResponseSchema = z.lazy(() => getCurrentUser200Schema)